"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesVolumePage = exports.SalesVolumeItem = void 0;
const zod_1 = require("zod");
/** SSC-235: quantities only. No customer, receipt, attendant or money fields. */
exports.SalesVolumeItem = zod_1.z.object({
    itemKey: zod_1.z.string().min(1).max(128),
    unit: zod_1.z.enum(['each', 'kg', 'l']),
    soldMicrounits: zod_1.z.string().regex(/^\d+$/),
    returnedMicrounits: zod_1.z.string().regex(/^\d+$/),
    /**
     * Sold and refunded receipt lines (scans) of this SKU and unit, whatever
     * the unit. The SecureScale worklist ranks by these. Optional so snapshots
     * cached before they existed still parse; readers treat absence as unknown.
     */
    soldLines: zod_1.z.number().int().nonnegative().optional(),
    returnedLines: zod_1.z.number().int().nonnegative().optional(),
});
exports.SalesVolumePage = zod_1.z.object({
    source: zod_1.z.literal('bos_receipts'),
    attribution: zod_1.z.literal('terminal_location_unverified'),
    storeId: zod_1.z.string().min(1),
    version: zod_1.z.string().uuid(),
    windowStart: zod_1.z.string().datetime(),
    windowEnd: zod_1.z.string().datetime(),
    asOf: zod_1.z.string().datetime(),
    items: zod_1.z.array(exports.SalesVolumeItem),
    cursor: zod_1.z.string().min(1),
    hasMore: zod_1.z.boolean(),
});
//# sourceMappingURL=sales-volume.js.map